import service from './index'

const prefix = '/common-uam';

// Type definitions
interface ReassignPrimaryTenantReqVO {
  userIds: string[];
  loginGroupId: number;
  mfaStatus?: number;
}
// preference
export const getUserPreferenceLanguage = () =>
  service.get(`${prefix}/session/user-settings`);

export const saveUserRecordLanguage = async (language: string) => {
  return service.put(`${prefix}/session/user-settings`, {
    language
  });
};

// ACL
export const getAclList = (pageSize: number = 1000000, pageNum: number = 1) => service.get(`${prefix}/acls/list?pageSize=${pageSize}&pageNum=${pageNum}`);

export const addACL = (aclInfo: {}) => service.post(prefix + '/acls', aclInfo);

export const updateACL = (aclInfo: {}) => service.put(prefix + '/acls', aclInfo);

export const updateACLStatus = (body: {}) => service.put(prefix + '/acls/status/active', body);

export const deleteAcl = (params: Object) => service.delete(prefix + `/acls/ids`, { data: params });

export const getAclMousules = () => service.get(prefix + `/resources/modules`);

export const getAclMousuleResource = (module: string, pageSize: number = 1000000, pageNum: number = 1) => service.get(prefix + `/resources/list?module=${module}&pageSize=${pageSize}&pageNum=${pageNum}`);

export const getAclModuleByAclId = (aclId: String) => service.get(prefix + `/acls/resources/${aclId}`);

export const exportAclList = (type: Number) => service.get(`${prefix}/acls/export/list?exportType=${type}`)

export const importAcl = (file: any) => service.post(`${prefix}/acls/import`)

export const importAclConfigFile = (formData: FormData) =>
  service({
    method: 'post',
    url: `${prefix}/acls/import/config`,
    data: formData,
  });

export const exportAclConfig = () =>
  service({
    method: 'get',
    url: `${prefix}/acls/export/config`,
    responseType: 'arraybuffer',
  });

export const checkAclDependencies = (params: Object) => service.get(`${prefix}/acls/dependencies`, { params })

export const getAclById = (aclId: string) => service.get(`${prefix}/acls/${aclId}`)

// User
export const getUserList = (pageSize: number = 1000000, pageNum: number = 1) => service.get(`${prefix}/users/list?pageSize=${pageSize}&pageNum=${pageNum}`);

export const getUserDetailList = (pageSize: number = 1000000, pageNum: number = 1) => service.get(`${prefix}/users/list/dynamic-details?pageSize=${pageSize}&pageNum=${pageNum}`);

/** Single-request User List: brief fields + KM-decoded dynamic details (flattened). */
export const getUserDetails = (pageSize: number = 1000000, pageNum: number = 1) =>
  service.get(`${prefix}/users/details?pageSize=${pageSize}&pageNum=${pageNum}`);

export const TENANT_USER_LIST = `${prefix}/users/list?pageSize=${1000000}&pageNum=${1}`;

export const getUserImpactList = (keyword: string, showUserType: string, pageSize: number, pageNum: number) => service.get(`${prefix}/users/list?keyword=${keyword}&showUserType=${showUserType}&pageSize=${pageSize}&pageNum=${pageNum}`);


export const addUser = (userInfo: {}) => service.post(prefix + '/users', userInfo);

export const getOrganizationList = () => service.get(prefix + '/organization/list');

export const updateUser = (body: {}) => service.put(prefix + '/users/basic-info', body);

export const updateUserStatus = (body: {}) => service.put(prefix + '/users/user-status', body);

export const getUserById = (userId: string) => service.get(`${prefix}/users/${userId}`);

export const exportUserList = (type: Number) => service.get(`${prefix}/users/export/list?exportType=${type}`)

export const getSameAclUser = (module: string, userId: string) => service.get(`${prefix}/users/reassign/same-acl-user?module=${module}&userId=${userId}`);

export const importUser = (body: any) => service.post(`${prefix}/users/import`, body);

export const fetchGetActiveUserList = () => service.get(`${prefix}/users/active-users`);

export const checkUserDependencies = (params: Object) => service.get(`${prefix}/users/dependencies`, { params })

export const getDomainList = () => service.get(`${prefix}/domains/list`);

export const getLoginGroupList = () => service.get(`${prefix}/login-groups/list`);

export const associateUsersWithTenants = (body: {}) => service.post(`${prefix}/user-tenant-relations/association`, body)

export const disAssociateUsersWithTenants = (body: {}) => service.post(`${prefix}/user-tenant-relations/disassociation`, body)

export const getTenantAssociationPermission = (userId: string) => service.get(`${prefix}/user-tenant-relations/tenant-association-permission?user-id=${userId}`);

export const getTenantAssociationPermissionV2 = (userId: string, tenantId: string) => service.get(`${prefix}/user-tenant-relations/tenant-association-permission/v2?user-id=${userId}&selected-tenant-id=${tenantId}`);

export const fetchGetTenantInfoList = (userId: string) => service.get(`${prefix}/user-tenant-relations/tenant-info-list?user-id=${userId}`);
// add encoder for reason
export const deleteUser = (id: string, reason: string) => service.delete(`${prefix}/users?userId=${id}&reason=${reason}`);

export const getUserBindGroupsByUserId = (userId: string) => service.get(`${prefix}/users/associated-groups/${userId}`);

export const getUserBindRolesByUserId = (userId: string) => service.get(`${prefix}/users/associated-roles/${userId}`);

export const putUserBindGroups = (body: {}) => service.put(`${prefix}/users/associated-groups`, body);

export const putUserBindRoles = (body: {}) => service.put(`${prefix}/users/associated-roles`, body);

export const putUserLockStatus = (userId: string, lockValue: Number) => service.put(`${prefix}/users/lock-status/${userId}/${lockValue}`);

export const setUserAsPrimaryTenant = (body: ReassignPrimaryTenantReqVO) => service.post(`${prefix}/users/reassign-primary-tenant`, body);

export const bindUserWithSingleGroup = (userId: string, groupId: string) => service.put(`${prefix}/users/group?userId=${userId}&groupId=${groupId}`);

export const bindUserWithSingleRole = (userId: string, roleId: string) => service.put(`${prefix}/users/role?userId=${userId}&roleId=${roleId}`);

export const unbindUserWithSingleRole = (userId: string, roleId: string) => service.delete(`${prefix}/users/role?userId=${userId}&roleId=${roleId}`);

export const unbindUserWithSingleGroup = (userId: string, groupId: string) => service.delete(`${prefix}/users/group?userId=${userId}&groupId=${groupId}`);

export const putUserBasicInfo = () => service.put(`${prefix}/users/basic-info`);

// Client
export const getClientList = () => service.get(`${prefix}/clients`);

export const addClient = (body: {}) => service.post(`${prefix}/clients`, body);

export const updateClientBasicInfo = (clientId: string, body: {}) => service.put(`${prefix}/clients/${clientId}`, body);

export const getClientById = (clientId: string) => service.get(`${prefix}/clients/${clientId}`);

/** Fetches the plaintext client secret for copy/reveal flows (detail API returns a masked value). */
export const queryClientSecret = (id: string) => service.get(`${prefix}/clients/${id}/secret`);

export const getClientBindRolesByClientId = (clientId: string) => service.get(`${prefix}/clients/${clientId}/roles`);

export const bindClientWithSingleRole = (clientId: string, roleId: string) => service.post(`${prefix}/clients/${clientId}/roles`, { roleId });

export const unbindClientWithSingleRole = (clientId: string, roleId: string) => service.delete(`${prefix}/clients/${clientId}/roles/${roleId}`);

export const checkClientDependencies = (params: Object) =>
  service.get(`${prefix}/clients/dependencies`, { params });

export const deleteClient = (clientId: string, reason: string) =>
  service.delete(`${prefix}/clients?clientId=${clientId}&reason=${reason}`);

/** Admin Center SCIM credential configuration (#277536). */
export const getScimConfig = () => service.get(`${prefix}/scim-admin/config`);

export const issueScimCredential = (body: {
  expiresInDays?: number | null;
}) => service.post(`${prefix}/scim-admin/credentials`, body);

export const rotateScimCredential = (body: {
  credentialId: string | number;
  gracePeriodHours: number;
  expiresInDays?: number | null;
}) => service.post(`${prefix}/scim-admin/credentials/rotate`, body);

export const revokeScimCredential = (body: { credentialId: string | number }) =>
  service.post(`${prefix}/scim-admin/credentials/revoke`, body);

export const deleteScimCredential = (body: { credentialId: string | number }) =>
  service.post(`${prefix}/scim-admin/credentials/delete`, body);

// Role
export const getRoleList = (pageSize: number = 1000000, pageNum: number = 1) => service.get(`${prefix}/roles/list?pageSize=${pageSize}&pageNum=${pageNum}`);

export const getRolesAssignableList = () => service.get(`${prefix}/roles/assignable/list`);

export const addRole = (roleInfo: {}) => service.post(prefix + '/roles', roleInfo);

export const updateRole = (roleInfo: {}) => service.put(prefix + '/roles', roleInfo);

export const relativeUser = (roleId: string) => service.get(`${prefix}/roles/relative/user?roleId=${roleId}`);

export const updateRoleStatus = (body: {}) => service.put(prefix + '/roles/status/active', body);

export const deleteRole = (params: Object) => service.delete(prefix + `/roles/ids`, { data: params });

export const bindACL = (requestBody: {}) => service.put(prefix + '/roles/acl/binding', requestBody)

export const getBindACL = (roleId: string) => service.get(`${prefix}/roles/acl/${roleId}`);

export const exportRoleList = (type: Number) => service.get(`${prefix}/roles/export/list?exportType=${type}`)

export const getRoleById = (roleId: string | Number) => service.get(prefix + `/roles/${roleId}`);

/**
 * Role levels the current user may pick. An empty list means the control must be hidden - it covers both
 * "the tenant has the feature off" and "the caller is an ordinary user", so the UI needs no rule of its own
 * and no feature flag lookup.
 */
export const getAssignableRoleLevels = () => service.get(prefix + '/roles/assignable-role-levels');

export const importRole = (file: any) => service.post(`${prefix}/roles/import`)

export const importRoleConfigFile = (formData: FormData) =>
  service({
    method: 'post',
    url: `${prefix}/roles/import/config`,
    data: formData,
  });

export const exportRoleConfig = () =>
  service({
    method: 'get',
    url: `${prefix}/roles/export/config`,
    responseType: 'arraybuffer',
  });

export const checkRoleDependencies = (params: Object) => service.get(`${prefix}/roles/dependencies`, { params })

// add encoder for reason
export const getRoleBindUserByRoleId = (roleId: Number) => service.get(`${prefix}/roles/user/${roleId}`);

export const getRoleBindGroupsByRoleId = (roleId: Number) => service.get(`${prefix}/roles/group/${roleId}`);

export const getRoleBindAclByRoleId = (roleId: Number) => service.get(`${prefix}/roles/acl/${roleId}`);

export const putRoleBindGroups = (roleId: any, groupId: any) => service.put(`${prefix}/roles/group?roleId=${roleId}&groupId=${groupId}`);

export const putRoleBindUsers = (roleId: any, userId: any) => service.put(`${prefix}/roles/user?roleId=${roleId}&userId=${userId}`);

export const putRoleBindAcls = (roleId: any, aclId: any) => service.put(`${prefix}/roles/acl?roleId=${roleId}&aclId=${aclId}`);

export const deleteRoleBindGroups = (roleId: any, groupId: any) => service.delete(`${prefix}/roles/group?roleId=${roleId}&groupId=${groupId}`);

export const deleteRoleBindUsers = (roleId: any, userId: any) => service.delete(`${prefix}/roles/user?roleId=${roleId}&userId=${userId}`);

export const deleteRoleBindAcls = (roleId: any, aclId: any) => service.delete(`${prefix}/roles/acl?roleId=${roleId}&aclId=${aclId}`);

// Group
export const getGroupList = () => service.get(prefix + '/groups/list');

export const getGroupById = (groupId: string) => service.get(`${prefix}/groups/${groupId}`);

export const getGroupDimensions = (groupId: string) => service.get(`${prefix}/groups/${groupId}/dimensions`);

export const saveGroupDimensions = (groupId: string, body: {}) => service.put(`${prefix}/groups/${groupId}/dimensions`, body);

export const queryDimensionConcepts = (dimensionsKmVersion?: string) => service.post(`${prefix}/groups/dimensions/km/concepts`, { dimensionsKmVersion });

export const queryDimensionValues = (concept: string, dimensionsKmVersion?: string) => service.post(`${prefix}/groups/dimensions/km/values`, { concept, dimensionsKmVersion });

export const getBasicGroupList = () => service.get(prefix + '/groups/list/basic-info');

export const addGroup = (body: {}) => service.post(prefix + '/groups', body);

export const updateGroup = (body: {}) => service.put(prefix + '/groups/basic-info', body);

export const updateGroupStatus = (body: {}) => service.put(prefix + '/groups/group-status', body);

export const deleteGroup = (id: string, reason: string) => service.delete(`${prefix}/groups?groupId=${id}&reason=${reason}`);

export const putGroupBindUsers = (body: {}) => service.put(`${prefix}/groups/associated-users`, body);

export const getGroupBindUsersByGroupId = (groupId: string) => service.get(`${prefix}/groups/associated-users/${groupId}`);

export const getGroupBindRolesByGroupId = (groupId: string) => service.get(`${prefix}/groups/associated-roles/${groupId}`);

export const putGroupBindRoles = (body: {}) => service.put(`${prefix}/groups/associated-roles`, body);

export const bindGroupWithSingleUser = (userId: string, groupId: string) => service.put(`${prefix}/groups/user?userId=${userId}&groupId=${groupId}`);

export const bindGroupWithSingleRole = (groupId: string, roleId: string) => service.put(`${prefix}/groups/role?groupId=${groupId}&roleId=${roleId}`);

export const unbindGroupWithSingleRole = (groupId: string, roleId: string) => service.delete(`${prefix}/groups/role?groupId=${groupId}&roleId=${roleId}`);

export const unbindGroupWithSingleUser = (userId: string, groupId: string) => service.delete(`${prefix}/groups/user?userId=${userId}&groupId=${groupId}`);

export const exportGroupList = (type: Number) => service.get(`${prefix}/groups/export/list?exportType=${type}`)

export const importGroup = (file: any) => service.post(`${prefix}/groups/import`)

export const importGroupConfigFile = (formData: FormData) =>
  service({
    method: 'post',
    url: `${prefix}/groups/import/config`,
    data: formData,
  });

export const exportGroupConfig = () =>
  service({
    method: 'get',
    url: `${prefix}/groups/export/config`,
    responseType: 'arraybuffer',
  });

export const checkGroupDependencies = (params: Object) => service.get(`${prefix}/groups/dependencies`, { params })

// Distribution
export const getDistributionList = () => service.get(`${prefix}/distribution/all`)

export const getDistributionById = (distributionId: string) => service.get(`${prefix}/distribution/${distributionId}`);

export const addDistribution = (body: {}) => service.post(prefix + '/distribution', body);

export const updateDistribution = (body: {}) => service.put(prefix + '/distribution', body);

export const bindIdentifiers = (body: {}) => service.post(`${prefix}/identifiers/binding`, body);

export const queryIdentifier = (body: {}) => service.post(`${prefix}/identifiers/query`, body);
// id: string, reason: string  ?id=${id}&reason=${reason}
export const deleteDistribution = (params: Object) => service.delete(`${prefix}/distribution`, { params });

// Resource
export const getResourceList = () => service.get(prefix + '/resources/list');

export const addResource = () => service.post(prefix + '/resources');

export const updateResource = () => service.put(prefix + '/resources');

export const deleteResource = () => service.delete(prefix + '/resources');

export const getSpecifyResourceList = (body: any) => service.post(prefix + '/resources/specified/list', body);

export const getRelatedMenuResourceList = (body: any) => service.post(prefix + '/resources/menu/related-resource', body);

export const getQuickSiteResourceList = () => service.get(prefix + '/resources/quick-sight/list');

export const getSpecifyRelatedResourceList = (body: any) => service.post(prefix + '/resources/specified/related-list', body);

// audit
export const getUAMAuditInfo = (params = {}) => service.post(prefix + '/log/audit-info', params);

// Test403
export const testResource2 = () => service.get(prefix + '/content/record');
export const testResource3 = () => service.get(prefix + '/content/extracted');

// DeleteRecords
export const getDeleteRecordByType = (type: number) => service.get(`${prefix}/log/list/delete-record?deleteRecordType=${type}`);

export const getDeleteRecordDynamicType = (type: number) => service.get(`${prefix}/log/list/delete-record/json-details?deleteRecordType=${type}`);

export const getStatusChangeLogByType = (recordId: string, type: number) => service.get(`${prefix}/log/list/status-change-log?recordId=${recordId}&recordType=${type}`);

export const getImportTemplate = (params = {}) => service.post(`${prefix}/import/template`, params);

export const EXPORT_ACL_URL = `${prefix}/acls/export/list`;

export const EXPORT_GROUPS_URL = `${prefix}/groups/export/list`;

export const EXPORT_USERS_URL = `${prefix}/users/export/list`;

export const EXPORT_ROLES_URL = `${prefix}/roles/export/list`;

export const IMPORT_ACL_URL = `${prefix}/import/acl`;

export const IMPORT_GROUPS_URL = `${prefix}/import/user-group`;

export const IMPORT_USERS_URL = `${prefix}/import/user`;

export const IMPORT_ROLES_URL = `${prefix}/import/role`;

export const IMPORT_DISTRIBUTION_URL = `${prefix}/import/distribution`;

export const DOWNLOAD_TEMPLATE_URL = `${prefix}/import/template`;

export const UAM_PREFIX = prefix;

//e-signauture password
export const judgeUserHasSignaturePassword = () => service.get(`${prefix}/users/e-signature/exist`);

export const createElectronicSignaturePassword = (params: {}) => service.post(`${prefix}/users/e-signature`, params);

export const updateElectronicSignaturePassword = (params: {}) => service.put(`${prefix}/users/e-signature`, params);

export const getUserListWorkflowRole = (roleName: string) => service.get(`${prefix}/roles/user/list?roleName=${roleName}`);

// System Settings
export const getSystemSettings = () => service.get(`${prefix}/system-settings/`);
export const udpateSystemSettings = (body: any) => service.put(`${prefix}/system-settings/`, body);
export const resetSystemSettings = () => service.put(`${prefix}/system-settings/resetting`);

//custom form settings
export const fetchFormSettings = (tenantId: number) => service.get(`${prefix}/system/form-settings?tenant-id=${tenantId}`);
export const saveFormSettings = (params: {}) => service.post(`${prefix}/system/form-settings`, params);

// menu
export const fetchDomain = () => service.get(`${prefix}/tm/domains`);
export const fetchModule = (domainId: string) => service.get(`${prefix}/tm/subscription/modules?domainId=${domainId}`);

export const getUserSessionDetails = (domainId: string) => service.get(`${prefix}/session/details?domainId=${domainId}`);

export const saveUserSession = (params: any) => service.post(`${prefix}/session/record`, params);

export const logout = (isSessionTimeout: boolean = false) => service.delete('/common-auth' + `/logout?session-timeout=${isSessionTimeout}`);


//tm
export const fetchDomainList = () => service.get(`${prefix}/tm/domains`);

//tag
export const addTag = (params: {}) => service.post(prefix + '/tags', params);

export const fetchTagList = (associatedId: any, associatedType: any = 0) => service.get(`${prefix}/tags/associated?associatedId=${associatedId}&associatedType=${associatedType}`);

export const bindRoleWithUsers = (roleId: number, userIds: number[]) => service.put(`${prefix}/roles/users`, { roleId, userIds });
export const bindGroupWithUsers = (groupId: number, userIds: number[]) => service.put(`${prefix}/groups/users`, { groupId, userIds });

// privilege
export const savePrivilege = (params: any) => service.post(`${prefix}/privilege/data/save`, params);
export const getPrivilege = (aclId: any) => service.get(`${prefix}/privilege/data/selected/${aclId}`);

// tenant settings
export const fetchTenantSettings = () => service.get(`${prefix}/system-settings/tenant-settings`);
